
import { ChevronDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import PromptUsageMeter from "@/components/prompts/PromptUsageMeter";

interface PromptLabHeaderProps {
  promptTitle: string | null;
  modelId: string;
  remainingCredits: number;
}

const PromptLabHeader = ({ promptTitle, modelId, remainingCredits }: PromptLabHeaderProps) => {
  return (
    <div className="border-b border-border/40 px-4 py-3 flex items-center justify-between bg-muted/30">
      <div className="flex flex-col gap-1">
        <div className="font-medium">
          {promptTitle || "Free-form Chat"}
        </div>
        <div className="text-xs text-muted-foreground flex items-center gap-2">
          <span>Model:</span>
          <Badge variant="outline" className="px-2 py-0 h-5">
            {modelId}
          </Badge>
        </div>
      </div>
      
      <div className="w-48">
        <PromptUsageMeter 
          usedCount={5 - remainingCredits} 
          limit={5} 
          percentUsed={((5 - remainingCredits) / 5) * 100} 
        />
      </div>
    </div>
  );
};

export default PromptLabHeader;
